import extendNode from '../extendNode.mjs'
import useAbstractNode from '../_ABSTRACT/useAbstractNode.jsx'
import meta from './metaUi_1.mjs'
import FormChoose from './FormChooseUi_1.jsx'
import TableChoose from './TableChooseUi_1.jsx'
import api from './apiUi_1.mjs'

export default () => {
    const AbstractNode = useAbstractNode()

    return extendNode(AbstractNode, {
        ...meta,
        api,
        FormChoose,
        TableChoose,
    })
}
